<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">
      <div class="row m-3 justify-content-center">

        <div class="col-lg-10">
          <div class="row">
            <div class="col-8">
              <p class="h5">
                  <b>Escolha a forma de pagamento</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 mt-2 pricing-rates business-rate" @click="selectPaymentMethod(paymentMethod)"
               style="cursor: pointer;" v-for="paymentMethod in paymentMethods">
            <div class="m-3">
              <b class="h6 text-primary">{{paymentMethod.paymeth_name}}</b>
              <i class="ms-1 fas fa-1x fa-arrow-circle-right text-primary"></i>
              <p class="text-muted mb-0">{{paymentMethod.additional_information}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import http from "@/helpers/http";

export default {
  name: 'ExamPaymentMethod',
  data() {
    return {
      search: '',
    }
  },
  computed: {
    paymentMethods() {
      let paymentMethods = this.$store.state.toSchedule.paymentMethods;
      if (this.search === '')
        return paymentMethods;

      return paymentMethods.filter(paymentMethod => {
        let strFilter = JSON.stringify(paymentMethod);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  mounted() {
    this.getPaymentMethods();
  },
  methods: {
    getPaymentMethods() {
      http.get('/schedule/exams/payment-methods', {
        params: {
          exam_type: this.$store.state.toSchedule.attendanceType,
          id_city: this.$store.state.toSchedule.schedule.city?.id_city,
          id_place: this.$store.state.toSchedule.place?.id_place,
        }
      }).then((paymentMethods) => {
        this.$store.commit('toSchedule/setPaymentMethods', paymentMethods.data)
      });
    },
    selectPaymentMethod(paymentMethod) {
      this.$store.commit('toSchedule/selectPaymentMethod', paymentMethod);
      if (paymentMethod.is_insurance) {
        this.$router.push('/exams/insurances');
      } else {
        this.$router.push('/exams/search');
      }
    },

  }
}
</script>

<style scoped>

</style>
